<script>
   /*************************************************************/
   /* Svelte component for calculation of PV-sets               */
   /*************************************************************/

   import { Select, Container, ButtonCancel, Button, Spinner } from './controls';
   import { pcvpca, pca_predict } from './wasm/pcvpca';
   import PCV from './wasm/pcv_wasm.js';

   // main properties of the whole app
   export let dataset = null;
   export let model = null;
   export let pvset = null
   export let pvres = null

   // error handling parameetrs
   let status = 'neutral';
   let errMsg = null;

   // PV-set calculation parameters
   let cvtypeOptions = ['ven', 'rand', 'loo'];
   let cvType = 'ven';

   // promise container for calculator
   let promise;

   // compute number of segments options based on dataset size
   let nsegOptions = dataset && dataset.values.nrows > 0 ?
      [2, 3, 4, 5, 10, 20].filter(v =>
         v >= (dataset.values.nrows / (dataset.values.nrows - model.ncomp - 1)) && v <= dataset.values.nrows / 2
      ) : [];

   // select first available option for number of segments as initial
   let nseg = nsegOptions.length > 0 ? nsegOptions[0] : 0;

   // if no options available (dataset is too small) - limit CV choice by LOO
   $: if (nsegOptions.length === 0) {
      cvtypeOptions = ['loo'];
      cvType = 'loo';
   }

   // function for downloading of PV-set
   function downloadPVSet(e) {
      const blob = new Blob([pvset.toCSV(dataset.sep, dataset.dec, dataset.header, dataset.labels)], { type: 'text/csv' });
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.setAttribute('href', url)
      a.setAttribute('download', 'pvset.csv');
      a.click()
   }

   // function that computes PV-set using given parameters
   async function computePVSet(data, model, cv) {
      promise = PCV()
         .then(Module => {
            const cv_type = cv.type == 'loo' ? 0 : cv.type == 'rand' ? 2 : 1;
            pvset = pcvpca(Module, model, data, model.ncomp, cv.nseg, cv_type, 0);
            pvres = pca_predict(Module, model, pvset);
         })
         .catch((e) => {
            pvset = null;
            pvres = null;
            status = 'error';
            errMsg = e;
         });
   }

   // event handler which triggers the model computation
   function compute(e) {
      status = 'neutral';
      errMsg = null;
      computePVSet(dataset.values, model, {type: cvType, nseg: nseg});
   }

   // function which resets the state of the component
   function reset() {
      status = 'neutral';
      errMsg = null;
      promise = null;
      pvset = null;
   }

   // if data file is empty reset status and error messages
   $: if (model === null) reset();

</script>


{#if (model && !pvset) && status !== 'busy'}

   <Container label='Split type:'>
      <Select id='cvType' bind:value={cvType} options={cvtypeOptions} />
   </Container>

   {#if cvType !== 'loo'}
   <Container label='Segments:'>
      <Select id='nseg' bind:value={nseg} options={nsegOptions} />
   </Container>
   {/if}

   <Container label=' '>
      <Button on:click={compute}>Compute PV-set</Button>
   </Container>
{/if}

{#if promise}

   {#await promise}
      <Container>
         <Spinner />
         <p>Computing PV-set...</p>
      </Container>
   {:then value}
      {#if pvset !== null}
      <Container>
         <p>PV-set is computed: {pvset.nrows} &times; {pvset.ncols}, {cvType} {cvType !== 'loo' ? nseg + ' seg' : ''}</p>
         <ButtonCancel on:click={reset} />
      </Container>
      <Container label=' '>
         <Button on:click={downloadPVSet}>Download</Button>
      </Container>
      {/if}

   {:catch error}
      <Container status='error'>
         <p>{error}</p>
      </Container>
   {/await}

{/if}

{#if status === 'error' && errMsg}
   <Container status='error'>
      <p>{errMsg}</p>
   </Container>
{/if}

